export default {
  english: {
    readingTime: '{{ time }} min',
  },
  french: {
    readingTime: '{{ time }} min',
  },
  arabic: {
    readingTime: 'دقيقة {{ time }}',
  },
  hebrew: {
    readingTime: '{{ time }} דקות',
  },
  persian: {
    readingTime: '{{ time }} دقیقه',
  },
}
